const PaketProgramEntity ={
    idPaketProgram: null,
    harga: null,
    setFree: null,
    idUpdatedBy: null,
    ussSbmptn: null,
    idKelasGroup: null,
    isEidupay: 0,
    namaProgram: null,
    startedDate: null,
    expiredDate: null,
    createdDate: null,
    updatedDate: null
}

export default PaketProgramEntity;